import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface TabButtonProps extends BoxProps {
  label: string;
  isSelected: boolean;
  to?: string;
}

const TabButton: React.FC<TabButtonProps> = ({
  label,
  isSelected,
  sx,
  ...props
}) => (
  <Box
    sx={{
      display: 'flex',
      px: 2,
      py: 1,
      width: 'fit-content',
      bgcolor: (theme) =>
        isSelected ? theme.palette.blue?.[50] : theme.palette.background.paper,
      boxSizing: 'border-box',
      border: (theme) =>
        isSelected
          ? `2px solid ${theme.palette.blue?.[300]}`
          : `1px solid ${theme.palette.gray?.[300]}`,
      borderRadius: 2,

      cursor: 'pointer',
      userSelect: 'none',
      textDecoration: 'none',
      color: 'inherit',
      ...sx,
    }}
    {...props}
  >
    <Typography noWrap variant={'subtitle2'}>
      {label}
    </Typography>
  </Box>
);

export default TabButton;
